<div
  [ngClass]="{ 'category-info': withName, 'category-thumb': !withName, 'skeleton': info?.name === 'skeleton' }"
  [ngStyle]="{ 'background-color': info?.color }"
>
  <ion-icon src="/assets/fontawesome/solid/{{ info?.icon }}.svg"></ion-icon>
  <span *ngIf="withName">{{ info?.name }}</span>
</div>
